import React from 'react';
import PropTypes from 'prop-types';

export const IconProviderApollo = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <g clipPath="url(#provider-apollo-clip-0)">
      <path
        d="M11.2 11.7733L12.27 10.7C12.27 10.7 11.9934 10.8933 9.56337 8.74663C7.13337 6.59996 6.41003 6.0133 6.41003 6.0133C6.41003 6.0133 6.8367 6.4833 9.1967 9.11997C11.1334 11.28 11.2267 11.6966 11.2 11.7733ZM15.5767 9.10997C17.7167 6.66996 18.3 5.9433 18.3 5.9433C18.3 5.9433 17.8334 6.36996 15.2067 8.7433C13.0567 10.6866 12.6434 10.78 12.5634 10.7533L13.6334 11.8266C13.6334 11.8266 13.44 11.55 15.5767 9.10997ZM12.5634 10.75L12.5434 10.73C12.5434 10.7333 12.5467 10.7466 12.5634 10.75ZM9.22004 14.7266C7.08337 17.1666 6.50004 17.8933 6.50004 17.8933C6.50004 17.8933 6.9667 17.4666 9.59337 15.0933C11.7434 13.15 12.1567 13.0566 12.2367 13.0833L11.1667 12.0133C11.1667 12.0133 11.36 12.29 9.22004 14.7266ZM12.2367 13.0866L12.2567 13.1066C12.2534 13.1066 12.2534 13.0933 12.2367 13.0866ZM15.6867 14.68C13.75 12.52 13.6567 12.1066 13.6867 12.0266L12.6167 13.1C12.6167 13.1 12.8934 12.9066 15.32 15.0533C17.75 17.2 18.4734 17.7866 18.4734 17.7866C18.4734 17.7866 18.05 17.32 15.6867 14.68Z"
        fill="url(#provider-apollo-paint-0)"
      />
      <path
        d="M7.80671 16.5434C8.19005 16.0967 8.68671 15.5267 9.31338 14.81C10.11 13.9 11.0034 12.8134 11.2334 12.2567L11.9967 13.0234C11.5767 13.2234 10.7434 13.8867 9.51005 15.0034C8.79338 15.65 8.23671 16.1534 7.80671 16.5434ZM17.1267 16.4734C16.6834 16.0867 16.1167 15.59 15.4034 14.9634C14.1934 13.8967 13.3134 13.2267 12.86 13.0334L13.62 12.27C13.77 12.5834 14.2367 13.2534 15.5934 14.7667C16.24 15.4834 16.74 16.0434 17.1267 16.4734ZM12.8 10.8134C13.22 10.6134 14.0534 9.95003 15.2867 8.83336C16.0034 8.18669 16.5567 7.68669 16.9867 7.29669C16.4881 7.87554 15.987 8.45221 15.4834 9.02669C14.6867 9.93669 13.7967 11.0234 13.5634 11.58L12.8 10.8134ZM11.2634 11.5334C11.1134 11.22 10.6467 10.5534 9.29004 9.03669C8.64671 8.31669 8.14671 7.76003 7.75671 7.32669C8.20005 7.71336 8.76671 8.21003 9.48005 8.83669C10.69 9.90336 11.57 10.5734 12.0234 10.7667L11.2634 11.5334Z"
        fill="url(#provider-apollo-paint-1)"
      />
      <path
        opacity="0.29"
        d="M11.0768 12.3867L10.4901 13.1933C10.4901 13.1933 11.0234 13.1333 11.1734 13.7433L11.9934 13.11L11.0768 12.3867Z"
        fill="url(#provider-apollo-paint-2)"
      />
      <path
        opacity="0.29"
        d="M11.9334 10.6067L10.9634 9.95667C10.9634 9.95667 11.0767 10.2933 10.3667 10.4767L11.1734 11.5633L11.9334 10.6067Z"
        fill="url(#provider-apollo-paint-3)"
      />
      <path
        opacity="0.29"
        d="M13.7867 11.41L14.1167 10.8967C14.1167 10.8967 13.5933 10.8533 13.4433 10.2433L12.8267 10.6933L13.7867 11.41Z"
        fill="url(#provider-apollo-paint-4)"
      />
      <path
        opacity="0.29"
        d="M12.9933 13.23L13.7833 13.7433C13.7833 13.7433 13.8366 13.3833 14.47 13.2633L13.7033 12.2733L12.9933 13.23Z"
        fill="url(#provider-apollo-paint-5)"
      />
      <path
        d="M24.2899 11.8467C24.2899 11.8467 21.9999 11.8167 18.4733 11.63C16.4733 11.5234 15.0966 11.3834 14.2766 11.28C13.4233 11.1367 13.1899 10.88 13.0733 10.0734C12.9566 9.2067 12.7933 7.76337 12.6733 5.8567C12.4666 2.6167 12.3666 0.0133667 12.3666 0.0133667C12.3666 0.0133667 12.3366 2.32003 12.1499 5.86337C12.0533 7.7067 11.9266 9.02337 11.8299 9.86337C11.7099 10.9067 11.4933 11.16 10.3866 11.31C9.5066 11.4234 8.15326 11.57 6.40326 11.6834C3.17326 11.89 0.593262 11.99 0.593262 11.99C0.593262 11.99 2.88326 12.02 6.40993 12.21C8.39659 12.3167 9.76993 12.4534 10.5899 12.5567C11.4566 12.7 11.6899 12.9534 11.8099 13.7667C11.8166 13.8234 12.0966 16.2167 12.2099 17.98C12.4166 21.2234 12.5133 23.8234 12.5133 23.8234C12.5133 23.8234 12.5433 21.5167 12.7299 17.9734C12.8399 15.8934 12.9866 14.4834 13.0899 13.6734C13.2233 12.88 13.4999 12.66 14.4933 12.5267C15.3699 12.4134 16.7299 12.2634 18.4799 12.1534C21.7066 11.9467 24.2899 11.8467 24.2899 11.8467Z"
        fill="url(#provider-apollo-paint-6)"
      />
      <path
        d="M12.5033 23.8234C12.5033 23.7967 12.4033 21.1834 12.1999 17.98C12.0866 16.1767 11.8033 13.7867 11.7999 13.7667C11.6799 12.94 11.4433 12.7034 10.5866 12.5634C9.78659 12.4634 8.41326 12.3234 6.4066 12.2167C2.92326 12.0334 0.616595 12 0.593262 12V11.9834C0.619928 11.9834 3.21326 11.8834 6.40326 11.6767C8.1866 11.5634 9.55326 11.41 10.3866 11.3034C10.9766 11.2234 11.2799 11.1167 11.4733 10.9167C11.6899 10.6967 11.7666 10.35 11.8233 9.86337C11.9566 8.73003 12.0666 7.3467 12.1433 5.86337C12.3266 2.36337 12.3599 0.0367 12.3599 0.0133667H12.3766C12.3766 0.0400334 12.4799 2.65337 12.6833 5.8567C12.8033 7.7767 12.9666 9.2067 13.0833 10.07C13.1999 10.8834 13.4466 11.13 14.2799 11.27C15.0866 11.37 16.4666 11.51 18.4733 11.6167C21.9599 11.8 24.2666 11.8334 24.2899 11.8334V11.85C24.2633 11.85 21.6699 11.9534 18.4799 12.1567C16.7033 12.27 15.3333 12.4234 14.4933 12.53C13.5033 12.6634 13.2299 12.8867 13.0966 13.67C12.9933 14.48 12.8466 15.8867 12.7366 17.97C12.5533 21.4734 12.5199 23.7967 12.5199 23.82L12.5033 23.8234ZM0.883263 11.9867C1.6066 12 3.63659 12.0534 6.40993 12.2C8.41326 12.3067 9.78993 12.4467 10.5899 12.5467C11.4433 12.6867 11.6966 12.9367 11.8166 13.7634C11.8199 13.7834 12.1033 16.1734 12.2166 17.9767C12.3799 20.56 12.4766 22.76 12.5099 23.53C12.5233 22.8 12.5766 20.76 12.7199 17.9734C12.8299 15.8867 12.9766 14.4834 13.0799 13.6734C13.2133 12.88 13.4866 12.6534 14.4899 12.52C15.3299 12.4134 16.7033 12.26 18.4766 12.1467C21.0499 11.9834 23.2333 11.8834 23.9999 11.8534C23.2766 11.84 21.2466 11.79 18.4733 11.64C16.4666 11.5334 15.0833 11.39 14.2766 11.29C13.4366 11.1467 13.1866 10.9 13.0666 10.0767C12.9499 9.21337 12.7899 7.78003 12.6666 5.86003C12.5033 3.2767 12.4066 1.0767 12.3733 0.3067C12.3599 1.0367 12.3066 3.0767 12.1599 5.86337C12.0833 7.35003 11.9733 8.73337 11.8399 9.86337C11.7833 10.3534 11.7066 10.7034 11.4866 10.9267C11.2899 11.1267 10.9833 11.2367 10.3899 11.3167C9.55659 11.4234 8.18993 11.5734 6.4066 11.69C3.82993 11.86 1.6466 11.9567 0.883263 11.9867Z"
        fill="#9A5422"
      />
      <path
        d="M12.4867 20.59C12.4433 19.8 12.3933 18.9133 12.3333 17.97C12.22 16.1967 11.9333 13.77 11.9333 13.75C11.8033 12.8667 11.52 12.5833 10.61 12.4333C9.80334 12.3333 8.42334 12.19 6.41667 12.0867C5.44334 12.0333 4.56 11.9933 3.79333 11.9633C4.58 11.92 5.47 11.87 6.41334 11.81C8.2 11.6967 9.57 11.5433 10.4033 11.4367C11.55 11.2833 11.8267 11.0067 11.9533 9.88001C12.09 8.73001 12.1967 7.38001 12.2767 5.87001C12.3267 4.89668 12.3667 4.01001 12.3967 3.24335C12.44 4.03335 12.49 4.92335 12.55 5.86668C12.6733 7.79001 12.8367 9.22668 12.95 10.09C13.0767 10.97 13.36 11.25 14.2567 11.4033C15.07 11.5033 16.4567 11.6467 18.4667 11.7533C19.44 11.8033 20.32 11.8433 21.0867 11.8733C20.3 11.9167 19.4133 11.9667 18.47 12.0267C16.69 12.14 15.3167 12.2933 14.4767 12.4C13.42 12.5433 13.11 12.8 12.9667 13.65C12.8633 14.4667 12.7167 15.8767 12.6067 17.9633C12.5567 18.94 12.5167 19.8233 12.4867 20.59Z"
        fill="url(#provider-apollo-paint-7)"
      />
      <path
        d="M4.22327 11.94C4.22327 11.94 5.15327 11.8767 6.54993 11.7833C7.2466 11.74 8.06327 11.67 8.93327 11.5867C9.3666 11.5433 9.8166 11.4933 10.2733 11.4367C10.4999 11.41 10.7299 11.3767 10.9533 11.3233C11.0666 11.2967 11.1733 11.26 11.2766 11.2133C11.3799 11.1633 11.4733 11.1033 11.5566 11.0233C11.6333 10.9433 11.6966 10.8467 11.7433 10.7433C11.7866 10.64 11.8233 10.53 11.8466 10.4167C11.8966 10.1933 11.9199 9.96333 11.9466 9.73333C11.9966 9.27666 12.0399 8.82666 12.0799 8.39333C12.1533 7.52333 12.2099 6.70666 12.2466 6.00999C12.3233 4.61333 12.3733 3.67999 12.3733 3.67999C12.3733 3.67999 12.3366 4.61333 12.2833 6.00999C12.2699 6.35999 12.2466 6.73666 12.2233 7.13999C12.1999 7.53999 12.1699 7.96333 12.1333 8.39999C12.0966 8.83666 12.0566 9.28666 12.0066 9.74333C11.9799 9.96999 11.9566 10.2033 11.9066 10.4333C11.8833 10.5467 11.8466 10.66 11.7999 10.77C11.7499 10.88 11.6833 10.98 11.5999 11.07C11.5133 11.1533 11.4099 11.22 11.3033 11.27C11.1933 11.3167 11.0799 11.3567 10.9666 11.3833C10.7366 11.4367 10.5066 11.47 10.2799 11.4967C9.82327 11.5533 9.37327 11.6 8.93994 11.6433C8.50327 11.6867 8.08327 11.72 7.68327 11.75C7.28327 11.78 6.9066 11.8033 6.5566 11.8233C5.1566 11.89 4.22327 11.94 4.22327 11.94ZM20.6533 11.9167C20.6533 11.9167 19.7233 11.98 18.3266 12.0733C17.6299 12.1167 16.8133 12.1867 15.9433 12.27C15.5099 12.3133 15.0599 12.3633 14.6033 12.42C14.3766 12.4467 14.1466 12.48 13.9233 12.5333C13.8099 12.56 13.7033 12.5967 13.5999 12.6433C13.4966 12.6933 13.4033 12.7533 13.3199 12.8333C13.2433 12.9133 13.1799 13.01 13.1333 13.1133C13.0899 13.2167 13.0533 13.3267 13.0299 13.44C12.9799 13.6633 12.9566 13.8933 12.9299 14.1233C12.8799 14.58 12.8366 15.03 12.7966 15.4633C12.7233 16.3333 12.6666 17.15 12.6299 17.8467C12.5533 19.2433 12.5033 20.1767 12.5033 20.1767C12.5033 20.1767 12.5399 19.2433 12.5933 17.8467C12.6066 17.4967 12.6299 17.12 12.6533 16.7167C12.6766 16.3167 12.7066 15.8933 12.7433 15.4567C12.7799 15.02 12.8199 14.57 12.8699 14.1133C12.8966 13.8867 12.9199 13.6533 12.9699 13.4233C12.9933 13.31 13.0299 13.1967 13.0766 13.0867C13.1266 12.9767 13.1933 12.8767 13.2766 12.7867C13.3633 12.7033 13.4666 12.6367 13.5733 12.5867C13.6833 12.54 13.7966 12.5 13.9099 12.4733C14.1399 12.42 14.3699 12.3867 14.5966 12.36C15.0533 12.3033 15.5033 12.2567 15.9366 12.2133C16.3733 12.17 16.7933 12.1367 17.1933 12.1067C17.5933 12.0767 17.9699 12.0533 18.3199 12.0333L20.6533 11.9167Z"
        fill="white"
      />
      <path
        opacity="0.4"
        d="M12.3967 3.24335L12.4801 20.5267C12.4801 20.5267 12.2667 16.5967 11.8901 13.5133C11.7067 12.0233 9.12341 11.63 9.12341 11.63C9.12341 11.63 10.2667 11.4967 10.6801 11.44C11.3734 11.3433 11.8368 11.1167 11.9134 10.3633C12.2667 6.99668 12.3967 3.24335 12.3967 3.24335Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="provider-apollo-paint-0"
        x1="11.246"
        y1="9.1833"
        x2="14.6937"
        y2="17.3556"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCB23D" />
        <stop offset="0.455" stopColor="#E78F26" />
        <stop offset="1" stopColor="#E68525" />
      </linearGradient>
      <linearGradient
        id="provider-apollo-paint-1"
        x1="11.5014"
        y1="9.79603"
        x2="14.179"
        y2="16.143"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F6ED56" />
        <stop offset="0.064" stopColor="#F8DB44" />
        <stop offset="0.134" stopColor="#FACF37" />
        <stop offset="0.205" stopColor="#FCC72F" />
        <stop offset="0.281" stopColor="#FCC52C" />
        <stop offset="0.668" stopColor="#F79149" />
        <stop offset="1" stopColor="#F37045" />
      </linearGradient>
      <linearGradient
        id="provider-apollo-paint-2"
        x1="11.5384"
        y1="12.741"
        x2="11.1348"
        y2="13.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.157" stopColor="#030303" />
        <stop offset="0.286" stopColor="#0E0E0E" />
        <stop offset="0.406" stopColor="#1F1F1F" />
        <stop offset="0.521" stopColor="#373737" />
        <stop offset="0.631" stopColor="#575757" />
        <stop offset="0.739" stopColor="#7D7D7D" />
        <stop offset="0.843" stopColor="#ABABAB" />
        <stop offset="0.944" stopColor="#DFDFDF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="provider-apollo-paint-3"
        x1="11.491"
        y1="11.019"
        x2="11.153"
        y2="10.6483"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.157" stopColor="#030303" />
        <stop offset="0.286" stopColor="#0E0E0E" />
        <stop offset="0.406" stopColor="#1F1F1F" />
        <stop offset="0.521" stopColor="#373737" />
        <stop offset="0.631" stopColor="#575757" />
        <stop offset="0.739" stopColor="#7D7D7D" />
        <stop offset="0.843" stopColor="#ABABAB" />
        <stop offset="0.944" stopColor="#DFDFDF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="provider-apollo-paint-4"
        x1="13.3333"
        y1="11.0273"
        x2="13.704"
        y2="10.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.157" stopColor="#030303" />
        <stop offset="0.286" stopColor="#0E0E0E" />
        <stop offset="0.406" stopColor="#1F1F1F" />
        <stop offset="0.521" stopColor="#373737" />
        <stop offset="0.631" stopColor="#575757" />
        <stop offset="0.739" stopColor="#7D7D7D" />
        <stop offset="0.843" stopColor="#ABABAB" />
        <stop offset="0.944" stopColor="#DFDFDF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="provider-apollo-paint-5"
        x1="13.3506"
        y1="12.7533"
        x2="13.77"
        y2="13.1616"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.157" stopColor="#030303" />
        <stop offset="0.286" stopColor="#0E0E0E" />
        <stop offset="0.406" stopColor="#1F1F1F" />
        <stop offset="0.521" stopColor="#373737" />
        <stop offset="0.631" stopColor="#575757" />
        <stop offset="0.739" stopColor="#7D7D7D" />
        <stop offset="0.843" stopColor="#ABABAB" />
        <stop offset="0.944" stopColor="#DFDFDF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="provider-apollo-paint-6"
        x1="12.4419"
        y1="0.0150334"
        x2="12.4419"
        y2="23.8227"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F6ED56" />
        <stop offset="0.064" stopColor="#F8DB44" />
        <stop offset="0.134" stopColor="#FACF37" />
        <stop offset="0.205" stopColor="#FCC72F" />
        <stop offset="0.281" stopColor="#FCC52C" />
        <stop offset="0.668" stopColor="#F79149" />
        <stop offset="0.888" stopColor="#F37045" />
        <stop offset="1" stopColor="#F04C46" />
      </linearGradient>
      <linearGradient
        id="provider-apollo-paint-7"
        x1="9.96333"
        y1="7.62368"
        x2="15.1087"
        y2="16.5503"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2ED71" />
        <stop offset="0.455" stopColor="#FFD72B" />
        <stop offset="1" stopColor="#F9A02D" />
      </linearGradient>
      <clipPath id="provider-apollo-clip-0">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

IconProviderApollo.propTypes = {
  className: PropTypes.string,
};

IconProviderApollo.defaultProps = {
  className: '',
};
